import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Profile from './components/Profile';
import Experience from './components/Experience';
import Portfolio from './components/Portfolio';
import Certificates from './components/Certificates';
import RuleOfLife from './components/RuleOfLife'; // <--- Import Komponen Baru
import Footer from './components/Footer';
import GameSimple from './components/GameMenu';
import BookReviewPage from './pages/hobby/BookReview';
import GalleryPage from './pages/hobby/Gallery';
import DrawPage from './pages/hobby/DrawGallery';
import GamingPage from './pages/hobby/Gaming';
import MusicPage from './pages/hobby/MusicPage';
import MoviePage from './pages/hobby/MoviePage';

import AnimatedBackground from './components/AnimatedBackground';
import LoadingScreen from './components/LoadingScreen';
import ThemeTransitionOverlay from './components/ThemeTransitionOverlay';
import { ThemeProvider } from './context/ThemeContext';

const MainPage = () => {
  const [activeSection, setActiveSection] = useState('profile');

  const profileRef = useRef(null);
  const experienceRef = useRef(null);
  const portfolioRef = useRef(null);
  const certificatesRef = useRef(null);
  const ruleOfLifeRef = useRef(null); // <--- Ref Baru

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    
    const sectionRefs = {
      'profile': profileRef,
      'experience': experienceRef,
      'portfolio': portfolioRef,
      'certificates': certificatesRef,
      'rule-of-life': ruleOfLifeRef // <--- Pemetaan Section
    };
    
    if (sectionRefs[sectionId] && sectionRefs[sectionId].current) {
      sectionRefs[sectionId].current.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      
      const sections = [
        { id: 'profile', ref: profileRef },
        { id: 'experience', ref: experienceRef },
        { id: 'portfolio', ref: portfolioRef },
        { id: 'certificates', ref: certificatesRef },
        { id: 'rule-of-life', ref: ruleOfLifeRef } // <--- Penjejakan Scroll
      ];
      
      let currentSection = 'profile';
      
      for (const section of sections) {
        if (section.ref.current) {
          const sectionTop = section.ref.current.offsetTop;
          const sectionHeight = section.ref.current.offsetHeight;
          
          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            currentSection = section.id;
            break;
          }
        }
      }
      
      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen" style={{background: 'transparent'}}>
      <Header activeSection={activeSection} setActiveSection={scrollToSection} />
      
      <div ref={profileRef}>
        <Profile />
      </div>

      <div ref={ruleOfLifeRef}>
        <RuleOfLife />
      </div>
      
      <div ref={experienceRef}>
        <Experience />
      </div>

      
      <div ref={portfolioRef}>
        <Portfolio />
      </div>
      
      <div ref={certificatesRef}>
        <Certificates />
      </div>

      <GameSimple />
      
      <Footer />
    </div>
  );
};

function App() {
  const [loading, setLoading] = useState(
    !sessionStorage.getItem('visited')
  );
  
  return (
    <ThemeProvider>
      <Router>
        {loading && <LoadingScreen onDone={() => setLoading(false)} />}
        <ThemeTransitionOverlay />
        <AnimatedBackground />
        <div className="App">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/book-review" element={<BookReviewPage />} />
            <Route path="/photography" element={<GalleryPage />} />
            <Route path="/draw-gallery" element={<DrawPage />} />
            <Route path="/gaming" element={<GamingPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/movie-review" element={<MoviePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center pixel-border p-8">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4 pixel-font">404</h1>
        <p className="text-xl text-gray-600 mb-6">Halaman tidak ditemukan</p>
        <a 
          href="/" 
          className="pixel-button bg-blue-600 text-white px-6 py-3 hover:bg-blue-700 inline-block"
        >
          Kembali ke Beranda
        </a>
      </div>
    </div>
  );
};

export default App;